import { get, has } from 'lodash'
import { Component } from 'react'

import { substitutedString } from './Utils'

interface BaseAdaptiveCardProps {
  actionHandler(...args: unknown[]): unknown
  card: object
  notification?: object
  onError?(...args: unknown[]): unknown
  onSuccess?(...args: unknown[]): unknown
  type?: string
}

export default class BaseAdaptiveCard extends Component<BaseAdaptiveCardProps> {
  static displayName = 'BaseAdaptiveCard'
  static defaultProps = {
    type: 'adaptive-card',
    onSuccess: () => {},
    onError: () => {}
  }

  constructor(props: any) {
    super(props)
    this.registerInputCallback = this.registerInputCallback.bind(this)
    this.actionHandler = this.actionHandler.bind(this)
    this.inputs = []

    this.state = {
      inlineDetailCard: null
    }
  }

  componentDidMount() {
    const { onError, onSuccess, notification } = this.props
    // @ts-expect-error
    if (notification.status === 'error') {
      // @ts-expect-error
      onError(notification.error)
      // @ts-expect-error
    } else if (notification.status === 'submitted') {
      // @ts-expect-error
      onSuccess(notification)
    }
  }

  static supportedSchemaVersion = 2

  inputs: any
  ref: any

  registerInputCallback(input: any) {
    this.inputs.push(input)
  }

  async actionHandler(actionType: any, actionTitle: any, ...options: any[]) {
    let actionInformation = {
      actionTitle: actionTitle,
      actionType: actionType,
      notification: this.props.notification,
      hasConfirmation: get(options, '[0].confirmation', null) != null,
      ref: get(this, 'ref.current', this.ref)
    }

    let isValid = true
    let shouldPropagate = true

    const inputData = this.inputs.reduce((resultObj: any, currentObject: any) => {
      resultObj[currentObject.id()] = currentObject.value()
      return resultObj
    }, {})

    switch (actionType) {
      case 'Action.Submit': {
        if (get(options, '[0].causesValidation') !== false) {
          isValid = this.validateInputs()
        }
        const data = get(options, '[0].data', {})
        // @ts-expect-error
        actionInformation.data = Object.assign({ ...data }, { ...inputData })

        const analytics = get(options, '[0].analytics', {})
        // @ts-expect-error
        actionInformation.analytics = analytics

        if (!has(actionInformation, 'analytics.workgrid-panel')) {
          // @ts-expect-error
          actionInformation.analytics['workgrid-panel'] = 'summary'
        }

        break
      }
      case 'Action.Http': {
        const parsedBody = substitutedString(options[3], inputData)
        actionInformation = Object.assign({}, actionInformation, {
          url: options[0],
          method: options[1],
          headers: options[2],
          body: parsedBody
        })
        break
      }
      case 'Action.OpenUrl': {
        actionInformation = Object.assign({}, actionInformation, { url: options[0].url })
        break
      }
      case 'Action.ShowCard': {
        if (actionInformation.notification) {
          actionInformation = Object.assign({}, actionInformation, { card: options[0] })
        } else {
          // If you don't send a card I assume it's the select action for the card
          // We also say inline in the object since we have originally built this application to show one and
          //  only one detail section at a time.  With this new inline option we can show many!
          actionInformation = Object.assign({}, actionInformation, {
            // @ts-expect-error
            card: actionInformation.notification.card.selectAction.card
          })
          // Don't advertise above adaptive card
          shouldPropagate = false
          // @ts-expect-error
          this.setState(prevState => ({ inlineDetailCard: prevState.inlineDetailCard ? null : actionInformation }))
        }
        break
      }
      case 'Action.Delete': {
        actionInformation = Object.assign({}, actionInformation)
        break
      }
      default: {
        break
      }
    }

    if (isValid && shouldPropagate) {
      this.props.actionHandler(actionInformation)
    }
  }

  validateInputs() {
    let isValid = true
    this.inputs.forEach((input: any) => {
      const inputIsValid = input.validate()
      if (!inputIsValid) {
        isValid = false
      }
    })
    return isValid
  }

  render() {
    return <div />
  }
}
